<template>
  <div class="container-content-parent">
    <div class="container-detail-content">
      <div class="wrap-title">
        <b class="title-text">{{ dataDetail.owner }}</b>
        <div
          v-if="
            dataDetail.status == '006' && this.accessurl != 'operator_gudang'
          "
        >
          <button class="black-button" @click="showModalAttachment">
            Upload Document Withdrawal
          </button>
          <button class="black-button" @click="showModal">
            Client Detail FR
          </button>
        </div>
        <div
          v-else-if="
            dataDetail.status == '001' && this.accessurl != 'operator_gudang'
          "
        >
          <button class="black-button" @click="approveAction">Approve</button>
          <button class="black-button" @click="showModalReject">Reject</button>
        </div>
        <div
          v-else-if="
            this.accessurl == 'operator_gudang' && dataDetail.status == '005'
          "
        >
          <button class="black-button" @click="confirmWithdraw">
            Confirm Withdrawal
          </button>
          <button class="black-button" @click="showModal">
            Client Detail FR
          </button>
        </div>
        <div
          v-else-if="
            dataDetail.status == '004' ||
            dataDetail.status == '005' ||
            dataDetail.status == '006' ||
            dataDetail.status == '007'
          "
        >
          <button class="black-button" @click="showModal">
            Client Detail FR
          </button>
        </div>
      </div>
    </div>
    <div class="container-detail-content">
      <div class="fixed-weight">
        <div class="title-text2">PIC Name</div>
        <div class="value-pic-text">{{ dataDetail.pic_name }}</div>
      </div>
      <div class="fixed-weight">
        <div class="title-text2">Phone Number</div>
        <div class="value-pic-text">{{ dataDetail.phonenumber }}</div>
      </div>
      <div class="fixed-weight">
        <div class="title-text2">Email</div>
        <div class="value-pic-text">{{ dataDetail.email }}</div>
      </div>
    </div>

    <div class="container-detail-content">
      <div class="fixed-weight">
        <div class="label">Withdrawal Request Summary</div>
        <div class="container-detail-content">
          <div class="conter-with-border">
            <div>Weight</div>
            <span class="value-pic-text"
              >{{ dataDetail.total_weight }} gram</span
            >
          </div>

          <div class="conter-with-border">
            <div>Total Pieces</div>
            <span class="value-pic-text">{{ dataDetail.total_item }} pcs</span>
          </div>
        </div>
      </div>
    </div>

    <div class="container-detail-content">
      <div class="fixed-weight">
        <div class="title-text2">Withdrawal Date</div>
        <div class="value-pic-text2">
          {{ dataDetail.withdrawal_detail.pickup_time | formatDateTime }}
        </div>
      </div>
      <div class="fixed-weight">
        <div class="title-text2">Request Letter</div>
        <div class="value-pic-text-blue">
          <p @click="downloadPDF">
            {{ this.docName === "" ? "" : "Request Letter.pdf" }}
          </p>
        </div>
      </div>
    </div>
    <div class="conter-with-border">
      <div class="value-pic-text2 padding-bottom">LIST OF METAL</div>
      <table class="table">
        <thead>
          <tr>
            <th>Client</th>
            <th>Denom (gr)</th>
            <th>Quantity of Pieces</th>
            <th>Deposit Date</th>
            <th>Status</th>
            <th>Act</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(data, i) in dataMetal" :key="i">
            <td>{{ data.owner }}</td>
            <td>{{ data.weight }}</td>
            <td>1</td>
            <td>
              {{ data.metal_date | formatDate }}
            </td>
            <td v-if="data.withdrawal_edit != null">
              <span
                v-if="data.withdrawal_edit.status == '001'"
                class="status-withdrawal request"
                >Waiting for Metal Changes</span
              >
              <span v-else class="status-withdrawal request">Rejected</span>
            </td>
            <td v-else>
              <span
                v-show="data.status == '001'"
                class="status-withdrawal request"
                >Submitted</span
              >
              <span v-show="data.status == '002'" class="status-withdrawal kbi"
                >Approved</span
              >
              <span v-show="data.status == '003'" class="status-withdrawal abx"
                >Rejected</span
              >
              <span
                v-show="data.status == '004'"
                class="status-withdrawal handover"
                >Stored</span
              >
              <span
                v-show="data.status == '005'"
                class="status-withdrawal operator"
                >Process</span
              >
              <span v-show="data.status == '006'" class="status-withdrawal kbi"
                >Withdrawal</span
              >
              <span v-show="data.status == '007'" class="status-withdrawal abx"
                >KMI Confirmation</span
              >
            </td>
            <td>
              <img
                class="close-icon"
                src="@/assets/dot-vertical.svg"
                @click="togglePopover(data._id)"
              />

              <div
                v-if="
                  isStatusEligible(dataDetail.status) ||
                  accessurl == 'operator_gudang' ||
                  isWithdrawalEditEligible(data.withdrawal_edit)
                "
                class="popover"
              >
                <div v-if="showPopover === data._id" class="popover-content">
                  <button>
                    <span class="disable-color-text"> Edit Metal</span>
                  </button>
                  <button>
                    <span class="disable-color-text">Delete Metal</span>
                  </button>
                </div>
              </div>

              <div v-else class="popover">
                <div v-if="showPopover === data._id" class="popover-content">
                  <button @click="showEditMetal(data.metal_id)">
                    Edit Metal
                  </button>
                  <button @click="deleteMetal(data.metal_id)">
                    <span class="red-color-text">Delete Metal</span>
                  </button>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div
      v-show="
        this.reportDoc != '' ||
        this.listImgPrev.length != 0 ||
        this.listVidPrev.length != 0
      "
      class="conter-with-border-without-radius"
    >
      <div class="wrap-title">
        <div class="value padding-bottom">Attachment</div>
        <div class="value-pic-text-blue">
          <p @click="downloadImages">Download Attachment</p>
        </div>
      </div>
      <div
        v-show="this.reportDoc != ''"
        class="conter-with-border-without-radius"
      >
        <div class="fixed-weight">
          <span class="value padding-bottom">Report Document</span>
          <div class="value-pic-text-blue">
            <p @click="downloadPDFBeritaAcara">
              {{ this.reportDoc === "" ? "" : "Report Document.pdf" }}
            </p>
          </div>
        </div>
      </div>
      <div
        v-if="listImgPrev.length !== 0 || listVidPrev.length !== 0"
        class="conter-with-border-without-radius"
        style="overflow: auto"
      >
        <div class="value padding-bottom">Evidence Document</div>
        <div class="flex-container">
          <div
            v-for="(item, index) in listImgPrev"
            :key="'img_' + index"
            class="flex-item"
          >
            <div class="enter-text">
              <img
                class="img-attachment"
                :src="item"
                @click="showModalImgPrev(item)"
              />
            </div>
          </div>
          <div
            v-for="(item, index) in listVidPrev"
            :key="'vid_' + index"
            class="flex-item"
          >
            <video
              controls
              class="img-attachment"
              :src="item"
              @click="showModalVidPrev(item)"
            />
          </div>
        </div>
      </div>
    </div>

    <b-modal ref="img-prev" hide-footer title="Evidence Document">
      <div class="d-block">
        <img :src="selectedImg" class="img-size" alt="Preview" /></div
    ></b-modal>

    <b-modal ref="detail-FR" hide-footer title="Recipient by Client">
      <div class="d-block">
        <form action="updateMetal">
          <div class="form-group">
            <span>Recipient Name</span>
            <h6>{{ this.recipientName }}</h6>
          </div>
          <div class="form-group">
            <span>Recipient Phone Number</span>
            <h6>{{ this.recipientPhone }}</h6>
          </div>
          <div class="form-group">
            <span>Letter of Assignment</span>
            <div class="value-pic-text-blue">
              <p @click="downloadPDFAttachment">
                {{
                  this.recipientDoc === ""
                    ? ""
                    : this.getFileNameFromUrl(this.recipientDoc)
                }}
              </p>
            </div>
          </div>
          <div><span>Recipient Identity</span></div>
          <img class="img-size" :src="recipientKtp" />
          <span></span>
          <div><span>Recipient Selfie</span></div>
          <img class="img-size" :src="recipientSelfie" />
        </form>
      </div>
    </b-modal>

    <b-modal ref="edit-metal" hide-footer title="Edit Metal">
      <div class="d-block">
        <div class="form-group">
          <span>Serial Number</span>
          <select
            class="input-text"
            v-model="selectedMetal"
            id="metal"
            @change="handleMetalChange"
          >
            <option
              style="max-height: 20px; overflow-y: auto"
              v-for="dataMetalEdit in listMetal"
              :key="dataMetalEdit.id"
              :value="dataMetalEdit.serial_number"
            >
              {{ dataMetalEdit.serial_number }}
            </option>
          </select>
          <span>Jenis Emas</span>
          <input
            class="input-text"
            id="jenisEmas"
            v-model="this.jenisEmas"
            type="text"
            :disabled="true"
          />
          <span>Denom (gr)</span>
          <input
            class="input-text"
            v-model="this.domination"
            type="text"
            :disabled="true"
          />
          <span>Qty (Keping)</span>
          <input
            class="input-text"
            v-model="this.quantity"
            type="text"
            :disabled="true"
          />
          <span>Deposit Date</span>
          <h6>{{ this.depositDate | formatDate }}</h6>
          <span>Keterangan</span>
          <textarea
            class="input-textarea"
            v-model="note_withdrawal"
            type="text"
            :disabled="true"
          />
          <span>Alasan Pengajuan</span>
          <textarea
            class="input-textarea"
            v-model="approval_note"
            type="text"
          />
          <button
            v-if="this.old_metal_id != this.new_metal_id"
            class="black-button-submit"
            @click="updateMetal"
            type="submit"
          >
            Update Metal
          </button>
          <button v-else class="disable-button-submit" type="submit">
            Update Metal
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal ref="reason-reject" hide-footer title="Reject Request">
      <div class="d-block">
        <form action="">
          <span>Reasons for Rejection *</span>
          <textarea class="input-textarea" v-model="reject_note"> </textarea>
        </form>
        <button class="button-red-border" @click="rejectAction">Reject</button>
      </div>
    </b-modal>

    <b-modal ref="attachment" hide-footer title="Upload Document">
      <div class="d-block">
        <span>Report Document | Format: PDF</span>
        <div class="input-file">
          <input
            type="file"
            ref="customsDoc"
            @change="handleFileChange2"
            accept=".pdf"
          />
          <span v-if="loadDataCustomDoc" class="container-loading">
            <b-spinner></b-spinner>
          </span>
          <span v-else class="padding-left2 truncate">{{
            this.reportDoc == ""
              ? "No File Choosen"
              : this.getFileNameFromUrl(this.reportDoc)
          }}</span>
        </div>

        <span>Upload Evidence Document | Maximum 10 photos/videos</span>
        <div class="input-file">
          <button class="upload-button" @click="showModalFileUpload">
            Add File
          </button>
          <span v-if="loadingFiles" class="container-loading2">
            <b-spinner></b-spinner>
          </span>
          <span v-else class="padding-left2">No File Choosen</span>
        </div>
        <div class="file-upload">
          <div class="file-list">
            <div v-for="(file, index) in files" :key="index" class="file">
              <div>
                <div class="file-uploded">
                  <span class="truncate">{{ file.file.name }}</span>
                  <span
                    class="file-uploded-close-icon"
                    @click="cancelUpload(index)"
                  >
                    x</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <button class="black-button-submit" @click="onSubmitDoc">Submit</button>
      </div>
    </b-modal>

    <b-modal ref="upload-file" hide-footer title="Insert File">
      <input
        type="file"
        ref="fileInput"
        class="hidden-input"
        multiple
        @change="handleFileChange"
        accept=".jpg,.jpeg,.png,.mp4"
      />
      <div class="gray-background">
        <img
          class="close-icon"
          src="@/assets/alert-icon.svg"
          @click="togglePopover(withdrawal._id)"
        />
        <span>You can upload video or photo here</span>
      </div>

      <div class="container-uploaded-file">
        <div class="center-text">
          <div class="drop-area">
            <input
              class="drop-input"
              id="fileInput"
              type="file"
              ref="fileInput"
              multiple
              @change="handleFileChange"
              accept=".jpg,.jpeg,.png,.mp4"
            />
            <button class="custom-button">Choose File</button>
            <label class="drop-label" for="fileInput"
              >or drag files here</label
            >
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import JSZip from "jszip";

export default {
  data() {
    return {
      loadingFiles: false,
      previewImageUrl: "",
      typeWithdraw: "offexchange",
      currentPage: 1,
      perPage: 10,
      owner: "",
      startDate: "",
      endDate: "",
      status: "",
      serialNumber: "",
      activity: "withdrawal",
      hallmark: "",
      dateType: "",
      contract_id: "",
      badgeValue: 7,
      filterIsActive: false,
      showPopover: false,
      docName: "",
      reportDoc: "",
      inputData: false,
      maxfile: false,
      imgList: [
        { img: "@/assets/identity-img.jpeg" },
        { img: "@/assets/selfie-img.jpeg" },
        { img: "@/assets/identity-img.jpeg" },
        { img: "@/assets/selfie-img.jpeg" },
      ],
      files: [],
      fileName: "",
      dataMetal: [],
      dataDetail: [],
      dataHolding: [],
      detailMetal: [],
      dataImgUpload: [],
      rawData: {
        _id: "",
        report_doc: "",
        evidence_doc: [],
      },
      loadDataCustomDoc: false,
      imgPreview: "",
      listImgPrev: [],
      listVidPrev: [],
      recipientName: "",
      recipientPhone: "",
      recipientDoc: "",
      recipientSelfie: "",
      recipientKtp: "",
      urlDetailAdmin: "/v2/clearing/admin/abx/",
      urlDetailOperator: "/v2/clearing/operator/",
      accessurl: "",
      info: "",
      idData: "",
      selectedImg: "",
      listMetal: [],
      selectedMetal: "",
      jenisEmas: "",
      domination: "",
      depositDate: "",
      weight: "",
      fineness: "",
      selectedSerialNumber: "",
      idMetalSelected: "",
      quantity: "1",
      old_metal_id: "",
      new_metal_id: "",
      approval_note: "",
      note_withdrawal: "",
      reject_note: "",
    };
  },
  mounted() {
    axios
      .get(
        "https://asia-southeast1-quiet-stacker-245710.cloudfunctions.net/get-user-access-location"
      )
      .then((res) => {
        console.log(res);
        let info = JSON.stringify(res.data.cityData[0]);
        this.info = info;
      });

    this.accessurl = sessionStorage.getItem("username");
    this.withdrawal_id = this.$route.params.id;
    this.rawData._id = this.$route.params.id;
    this.idData = this.rawData._id;
    let url;
    url =
      this.accessurl == "operator_gudang"
        ? this.urlDetailOperator +
          "offexchange/get/detail/withdrawal/" +
          this.withdrawal_id
        : this.urlDetailAdmin +
          "offexchange/get/detail/withdrawal/" +
          this.withdrawal_id;

    axios.get(url).then((res) => {
      this.dataMetal = res.data.data.body.metal_info;
      this.dataDetail = res.data.data.body;
      console.log("DATA => " + JSON.stringify(this.dataDetail));
      this.typeWithdrawal = this.dataDetail.type;
      this.dataHolding = res.data.data.body.holding;
      this.withdrawal_status = res.data.data.body.status;
      if (this.dataDetail.withdrawal_detail.attachment.withdrawal_doc) {
        this.docName =
          this.dataDetail.withdrawal_detail.attachment.withdrawal_doc;
        this.fileName = this.getFileNameFromUrl(
          this.dataDetail.withdrawal_detail.attachment.withdrawal_doc
        );
      }
      if (this.dataDetail.withdrawal_detail.attachment.report_doc) {
        this.reportDoc =
          this.dataDetail.withdrawal_detail.attachment.report_doc;
      }
      this.recipientName = this.dataDetail.withdrawal_detail.recipient.name;
      this.recipientPhone =
        this.dataDetail.withdrawal_detail.recipient.phone_number;
      this.recipientDoc =
        this.dataDetail.withdrawal_detail.attachment.withdrawal_doc;

      const existingFiles =
        this.dataDetail.withdrawal_detail.attachment.evidence_doc.map(
          (fileUrl) => {
            const extension = fileUrl.split(".").pop().toLowerCase();
            const fileType =
              extension === "mp4"
                ? "video/mp4"
                : extension === "jpg" || extension === "jpeg"
                ? "image/jpeg"
                : "image/png";

            return {
              file: {
                name: this.getFileNameFromUrl(fileUrl),
                type: fileType,
                url: fileUrl,
              },
              canceled: false,
            };
          }
        );
      this.files = existingFiles;

      for (
        let i = 0;
        i <= this.dataDetail.withdrawal_detail.attachment.evidence_doc.length;
        i++
      ) {
        const extension =
          this.dataDetail.withdrawal_detail.attachment.evidence_doc[i]
            .split(".")
            .pop()
            .toLowerCase();
        console.log(extension);
        if (extension == "mp4") {
          this.getFullImageUrlVideo(
            this.dataDetail.withdrawal_detail.attachment.evidence_doc[i]
          );
        } else {
          this.getFullImageUrl(
            this.dataDetail.withdrawal_detail.attachment.evidence_doc[i]
          );
        }
      }

      for (let i = 0; i < this.dataMetal.length; i++) {
        this.form.allocated = this.dataMetal[i].allocated;
        this.form.hub = this.dataMetal[i].hub;
        this.form.dimension = this.dataMetal[i].dimension;
        this.form.fineness = this.dataMetal[i].fineness;
        this.form.hallmark = this.dataMetal[i].hallmark;
        this.form.serial_number = this.dataMetal[i].serial_number;
        this.form.year = this.dataMetal[i].year;
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.manageRows);
  },
  methods: {
    togglePopover(id) {
      if (this.showPopover === id) {
        this.showPopover = null;
      } else {
        this.showPopover = id;
      }
    },

    isStatusEligible(status) {
      return status == "006" || status == "008";
    },
    isWithdrawalEditEligible(withdrawal_edit) {
      return (
        withdrawal_edit != undefined &&
        withdrawal_edit != null &&
        withdrawal_edit.status == "001"
      );
    },

    getListMetalByOwner(idMetalSelected) {
      this.old_metal_id = idMetalSelected;
      this.$store
        .dispatch("getListMetalOffExchangeWithdraw", {
          owner: this.dataDetail.owner,
        })
        .then((res) => {
          res.metal.forEach((item) => {
            const existingItemIndex = this.listMetal.findIndex(
              (existingItem) => existingItem.metal_id === item.metal_id
            );
            if (existingItemIndex === -1) {
              if (item.status === "004" || item.metal_id === idMetalSelected) {
                this.listMetal.push(item);
                const defaultData = this.listMetal.find(
                  (item) => item.metal_id === idMetalSelected
                );
                if (defaultData) {
                  this.selectedMetal = defaultData.serial_number;
                }
              }
            } else {
              console.log(
                `Item with metal_id ${item.metal_id} already exists in the list.`
              );
            }
          });
          this.handleMetalChange();
        });
    },

    handleMetalChange() {
      const selectedDataMetal = this.listMetal.find((item) => {
        return item.serial_number === this.selectedMetal;
      });

      if (selectedDataMetal) {
        this.new_metal_id = selectedDataMetal.metal_id;
        (this.jenisEmas = selectedDataMetal.hallmark),
          (this.domination = selectedDataMetal.weight),
          (this.depositDate = selectedDataMetal.metal_date);
        this.note_withdrawal = selectedDataMetal.note_withdrawal;
      } else {
        this.jenisEmas = this.getMetal[0].hallmark;
      }
    },

    deleteMetal(id) {
      const requestData = {
        old_metal_id: id,
        approval_note: this.approval_note,
        action: "delete",
      };

      let urlEdit =
        "/v2/clearing/admin/abx/offexchange/withdrawal/" +
        this.$route.params.id +
        "/metal";

      axios.put(urlEdit, requestData).then((res) => {
        this.$refs["edit-metal"].hide();
        console.log(res);
        window.location.reload();
        this.$toast.success("Success delete Metal");
      });
    },

    updateMetal() {
      const requestData = {
        old_metal_id: this.old_metal_id,
        new_metal_id: this.new_metal_id,
        approval_note: this.approval_note,
        action: "edit",
      };

      let urlEdit =
        "/v2/clearing/admin/abx/offexchange/withdrawal/" +
        this.$route.params.id +
        "/metal";

      axios.put(urlEdit, requestData).then((res) => {
        this.$refs["edit-metal"].hide();
        console.log(res);
        window.location.reload();
        this.$toast.success("Success Update Metal");
      });
    },

    getData(
      currentPage,
      perPage,
      type,
      owner,
      startDate,
      endDate,
      status,
      serialNumber
    ) {
      this.$store.dispatch("getWithdraw", {
        currentPage: currentPage,
        perPage: perPage,
        type: type,
        owner: owner,
        startDate: startDate,
        endDate: endDate,
        status: status,
        serialNumber: serialNumber,
      });
    },
    handlePageChange(value) {
      this.currentPage = value;
      this.getData(
        this.currentPage,
        this.perPage,
        this.typeWithdraw,
        this.owner,
        this.startDate,
        this.endDate,
        this.status,
        this.serialNumber
      );
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    onCickFilterDetail(value) {
      this.filterIsActive = !value;
    },
    showModal() {
      this.getFullImageUrlRecipient(
        this.dataDetail.withdrawal_detail.recipient.ktp_pict
      );
      this.getFullImageUrlRecipientSelfie(
        this.dataDetail.withdrawal_detail.recipient.selfie
      );
      this.$refs["detail-FR"].show();
    },

    showModalReject() {
      this.$refs["reason-reject"].show();
    },

    showModalAttachment() {
      this.$refs["attachment"].show();
    },

    showModalImgPrev(imgData) {
      this.selectedImg = imgData;

      this.$refs["img-prev"].show();
    },

    showModalFileUpload() {
      this.$refs["upload-file"].show();
      this.$refs["attachment"].hide();
    },

    showEditMetal(idMetalSelected) {
      this.getListMetalByOwner(idMetalSelected);
      this.$refs["edit-metal"].show();
      this.showPopover = "";
    },

    async handleFileChange(event) {
      this.loadingFiles = true;
      const selectedFiles = Array.from(event.target.files);

      this.$refs["upload-file"].hide();
      this.$refs["attachment"].show();

      // Check total file count first
      if (this.files.length + selectedFiles.length > 10) {
        this.loadingFiles = false;
        alert("Pilih maksimum 10 file.");
        this.$refs.fileInput.value = null;
        return;
      }

      const validFiles = [];

      for (const file of selectedFiles) {
        const fileSize = file.size;

        if (fileSize > 100 * 1024 * 1024) {
          this.loadingFiles = false;
          alert("Ukuran file melebihi batas maksimum (100MB).");
          this.$refs.fileInput.value = null;
          return;
        }

        const fileType = file.type;

        if (
          fileType !== "image/jpeg" &&
          fileType !== "image/png" &&
          fileType !== "video/mp4"
        ) {
          this.loadingFiles = false;
          alert("Pilih file dengan tipe JPG, PNG, MP4.");
          this.$refs.fileInput.value = null;
          return;
        }

        validFiles.push(file);
      }

      try {
        const uploadPromises = validFiles.map((file) =>
          this.requestFormData(file).then((res) => {
            this.rawData.evidence_doc.push(res.data.data);
            return { file, canceled: false };
          })
        );

        const uploadedFiles = await Promise.all(uploadPromises);
        this.files = [...this.files, ...uploadedFiles];

        if (this.files.length > 10) {
          this.maxfile = true;
          alert("Pilih maksimum 10 file.");
        }
      } catch (error) {
        console.error("Error uploading files:", error);
      } finally {
        this.loadingFiles = false;
        this.$refs.fileInput.value = null;
      }
    },
    handleFileChange2(event) {
      this.loadDataCustomDoc = true;
      const fileCustomDoc = this.$refs.customsDoc.files[0];
      if (
        fileCustomDoc.type == "image/jpeg" ||
        fileCustomDoc.type == "image/jpg" ||
        fileCustomDoc.type == "image/png" ||
        fileCustomDoc.type == "application/pdf"
      ) {
        this.requestFormData(fileCustomDoc).then((res) => {
          this.loadDataCustomDoc = false;
          this.label_custom = fileCustomDoc.name;
          this.rawData.report_doc = res.data.data;
          this.reportDoc = res.data.data;
        });
      } else {
        this.loadDataCustomDoc = false;
        this.toast.error("File must be .jpg .png or .pdf");
      }
      const selectedFiles = event.target.files;
      const fileNames = Array.from(selectedFiles).map((file) => file.name);
      this.fileName = fileNames[0];
    },

    requestFormData(fileData) {
      let formData = new FormData();
      formData.append("file", fileData);
      formData.append("type", "withdrawal");
      formData.append("trx_id", this.dataDetail.client_id);
      return axios.post("/v2/upload/external", formData);
    },

    uploadFiles() {
      if (this.files.length === 0) {
        alert("Please select at least one file.");
        return;
      }
      console.log("Selected Files:");
      for (let i = 0; i < this.files.length; i++) {
        if (!this.files[i].canceled) {
          console.log(this.files[i].file.name);
        }
      }
      this.$refs.fileInput.value = "";
    },
    cancelUpload(index) {
      this.files.splice(index, 1);
    },
    manageRows() {
      const fileListWidth = this.$refs.fileList.clientWidth;
      const filesPerRow = Math.floor(fileListWidth / 100);
      if (filesPerRow !== this.filesPerRow) {
        this.filesPerRow = filesPerRow;
        this.$forceUpdate();
      }
    },

    approveAction() {
      let url;
      url =
        this.accessurl == "operator_gudang"
          ? this.urlDetailOperator
          : this.urlDetailAdmin + "offexchange/withdrawal/update";
      this.$store.dispatch("getLocation").then((resGeo) => {
        let info;
        if (resGeo.cityData[0]) {
          info = JSON.stringify(resGeo);
        } else {
          let data = resGeo;
          data.newLatLong = resGeo.cityLatLong.split(",");
          info = JSON.stringify(data);
        }

        let data;

        data = {
          _id: this.withdrawal_id,
          status: "002",
          info: info,
        };

        axios
          .put(url, data)
          .then((res) => {
            console.log(res);
            this.$toast.success("The withdraw Has been Approve");
            this.$router.push("/withdrawalOff");
          })
          .catch((err) => {
            this.$toast.error(err.response.data.message);
          });
      });
    },
    rejectAction() {
      let url;
      url =
        this.accessurl == "operator_gudang"
          ? this.urlDetailOperator
          : this.urlDetailAdmin + "offexchange/withdrawal/update";
      this.$store.dispatch("getLocation").then((resGeo) => {
        let info;
        if (resGeo.cityData[0]) {
          info = JSON.stringify(resGeo);
        } else {
          let data = resGeo;
          data.newLatLong = resGeo.cityLatLong.split(",");
          info = JSON.stringify(data);
        }

        let data;

        data = {
          _id: this.withdrawal_id,
          status: "008",
          reject_note: this.reject_note,
          info: info,
        };

        axios
          .put(url, data)
          .then((res) => {
            if (res.status == 200) {
              if (res.data.metal_info.status == "007") {
                this.$toast.success("The withdraw Has been Approve");
                this.$router.go("/withdrawalOff");
              } else {
                this.$toast.success("The withdraw cannot approve");
              }
              setTimeout(function () {
                location.reload();
              }, 3000);
            }
          })
          .catch((err) => {
            this.$toast.error(err.response.data.message);
          });
      });
      this.$router.push("/withdrawalOff");
    },
    onSubmitDoc() {
      this.$refs["attachment"].hide();
      const existingFileUrls = this.files.map((file) => file.file.url);

      const validFileUrls = existingFileUrls.filter((url) => url != null);
      this.rawData.evidence_doc.push(...validFileUrls);

      return axios
        .put(
          this.accessurl == "operator_gudang"
            ? this.urlDetailOperator
            : this.urlDetailAdmin + "offexchange/withdrawal/updateDoc",
          this.rawData
        )
        .then((res) => {
          if (res.status == 200) {
            this.$toast.success("Upload Document Success !!");
            window.location.reload();
          }
        })
        .catch((err) => {
          this.$toast.error(err.res.data.message);
        });
    },

    getFileNameFromUrl(url) {
      const parts = url.split("/");
      const fileName = parts[parts.length - 1];
      return fileName;
    },

    getFullImageUrlRecipient(imageName) {
      console.log(imageName);
      let base_url = axios.defaults.baseURL;
      const sig_url =
        base_url +
        "/v2/vms/withdrawal/images/" +
        this.dataDetail.client_id +
        "/" +
        this.getFileNameFromUrl(imageName);
      console.log(sig_url);
      const token = sessionStorage.getItem("token");
      const sigRequest = fetch(sig_url, {
        method: "GET",
        headers: {
          authorization: "Bearer " + token,
        },
      }).then((response) => response.blob());
      sigRequest.then((blob) => {
        this.recipientKtp = window.URL.createObjectURL(blob);
      });
    },

    getFullImageUrlRecipientSelfie(imageName) {
      console.log(imageName);
      let base_url = axios.defaults.baseURL;
      const sig_url =
        base_url +
        "/v2/vms/withdrawal/images/" +
        this.dataDetail.client_id +
        "/" +
        this.getFileNameFromUrl(imageName);
      console.log(sig_url);
      const token = sessionStorage.getItem("token");
      const sigRequest = fetch(sig_url, {
        method: "GET",
        headers: {
          authorization: "Bearer " + token,
        },
      }).then((response) => response.blob());
      sigRequest.then((blob) => {
        this.recipientSelfie = window.URL.createObjectURL(blob);
      });
    },

    getFullImageUrl(imageName) {
      console.log(imageName);
      let base_url = axios.defaults.baseURL;
      const sig_url =
        base_url +
        "/v2/vms/withdrawal/images/" +
        this.dataDetail.client_id +
        "/" +
        this.getFileNameFromUrl(imageName);
      console.log(sig_url);
      const token = sessionStorage.getItem("token");
      const sigRequest = fetch(sig_url, {
        method: "GET",
        headers: {
          authorization: "Bearer " + token,
        },
      }).then((response) => response.blob());
      sigRequest.then((blob) => {
        this.imgPreview = window.URL.createObjectURL(blob);
        this.listImgPrev.push(window.URL.createObjectURL(blob));
      });
    },

    addBlobToZip(zip, blob, fileName) {
      console.log("isiii 3 ......." + JSON.stringify(fileName));
      // Tambahkan file ke objek JSZip yang diberikan
      zip.file(fileName, blob);
    },

    downloadImages() {
      let zip = new JSZip();

      Promise.all(
        this.listVidPrev.map((vidUrl, index) => {
          return fetch(vidUrl)
            .then((response) => response.blob())
            .then((blob) => {
              this.addBlobToZip(zip, blob, "video_" + index + ".mp4");
            });
        })
      );

      Promise.all(
        this.listImgPrev.map((imgUrl, index) => {
          return fetch(imgUrl)
            .then((response) => response.blob())
            .then((blob) => {
              this.addBlobToZip(zip, blob, "image_" + index + ".jpg");
            });
        })
      ).then(() => {
        this.downloadImagesAsZip(zip);
      });
    },

    downloadImagesAsZip(zip) {
      console.log("download.......");
      let base_url = axios.defaults.baseURL;
      const token = sessionStorage.getItem("token");

      const sig_url =
        base_url +
        "/v2/vms/withdrawal/pdf/" +
        this.dataDetail.client_id +
        "/" +
        this.getFileNameFromUrl(
          this.dataDetail.withdrawal_detail.attachment.report_doc
        );
      fetch(sig_url, {
        method: "GET",
        headers: {
          authorization: "Bearer " + token,
        },
      })
        .then((response) => {
          return response.blob();
        })
        .then((blob) => {
          this.addBlobToZip(zip, blob, "attachment_file.pdf");

          this.generateAndDownloadZip(zip);
          console.log("selesai download.......");
        });
    },

    generateAndDownloadZip(zip) {
      zip.generateAsync({ type: "blob" }).then((zipBlob) => {
        console.log("selesai download 3 ......." + JSON.stringify(zipBlob));

        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(zipBlob);
        let fileName = "Attachment_files.zip";
        link.download = fileName;
        link.click();
      });
    },

    getFullImageUrlVideo(imageName) {
      console.log(imageName);
      let base_url = axios.defaults.baseURL;
      const sig_url =
        base_url +
        "/v2/vms/withdrawal/videos/" +
        this.dataDetail.client_id +
        "/" +
        this.getFileNameFromUrl(imageName);
      console.log(sig_url);
      const token = sessionStorage.getItem("token");
      const sigRequest = fetch(sig_url, {
        method: "GET",
        headers: {
          authorization: "Bearer " + token,
        },
      }).then((response) => response.blob());
      sigRequest.then((blob) => {
        this.imgPreview = window.URL.createObjectURL(blob);
        this.listVidPrev.push(window.URL.createObjectURL(blob));
      });
    },

    async downloadPDF() {
      let base_url = axios.defaults.baseURL;
      const sig_url =
        base_url +
        "/v2/vms/withdrawal/pdf/" +
        this.dataDetail.client_id +
        "/" +
        this.getFileNameFromUrl(
          this.dataDetail.withdrawal_detail.attachment.withdrawal_doc
        );
      console.log(sig_url);
      const token = sessionStorage.getItem("token");

      const response = await fetch(sig_url, {
        method: "GET",
        headers: {
          authorization: "Bearer " + token,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch PDF");
      }

      const arrayBuffer = await response.arrayBuffer();
      const blob = new Blob([arrayBuffer], { type: "application/pdf" });

      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      let fileName =
        "request-letter - " + this.getFileNameFromUrl(response.url);
      link.download = fileName;
      link.click();
    },

    async downloadPDFBeritaAcara() {
      try {
        let base_url = axios.defaults.baseURL;
        const sig_url =
          base_url +
          "/v2/vms/withdrawal/pdf/" +
          this.dataDetail.client_id +
          "/" +
          this.getFileNameFromUrl(
            this.dataDetail.withdrawal_detail.attachment.report_doc
          );
        console.log(sig_url);
        const token = sessionStorage.getItem("token");

        const response = await fetch(sig_url, {
          method: "GET",
          headers: {
            authorization: "Bearer " + token,
          },
        });

        const arrayBuffer = await response.arrayBuffer();
        const blob = new Blob([arrayBuffer], { type: "application/pdf" });

        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        let fileName =
          "request-letter - " + this.getFileNameFromUrl(response.url);
        link.download = fileName;
        link.click();
      } catch (error) {
        console.error("Error downloading PDF:", error);
      }
    },

    async downloadPDFAttachment() {
      try {
        let base_url = axios.defaults.baseURL;
        const sig_url =
          base_url +
          "/v2/vms/withdrawal/pdf/" +
          this.dataDetail.client_id +
          "/" +
          this.getFileNameFromUrl(
            this.dataDetail.withdrawal_detail.attachment.withdrawal_doc
          );
        console.log(sig_url);
        const token = sessionStorage.getItem("token");

        const response = await fetch(sig_url, {
          method: "GET",
          headers: {
            authorization: "Bearer " + token,
          },
        });

        const arrayBuffer = await response.arrayBuffer();
        const blob = new Blob([arrayBuffer], { type: "application/pdf" });

        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        let fileName =
          "request-letter - " + this.getFileNameFromUrl(response.url);
        link.download = fileName;
        link.click();
      } catch (error) {
        console.error("Error downloading PDF:", error);
      }
    },

    confirmWithdraw() {
      this.requestFormDataConfirm().then((res) => {
        if (res.status == 200) {
          this.$router.push("/withdrawalOff");
        }
      });
    },

    requestFormDataConfirm() {
      let formData = new FormData();
      formData.append("_id", this.idData);
      formData.append("info", this.info);

      return axios.put(
        "/v2/clearing/operator/offexchange/withdrawal/update",
        formData
      );
    },
  },

  computed: {
    getWithdrawData() {
      return this.$store.state.vaultModul.withdrawData;
    },
    getTotalData() {
      return this.$store.state.vaultModul.totalData;
    },
  },
};
</script>

<style scoped>
.container-content-parent {
  padding: 3em;
}

.wrap-title {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.container-detail-content {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 2rem;
  padding-top: 5px;
}

.total-weight,
.fixed-weight {
  margin-bottom: 20px;
  text-align: start;
}

.black-button {
  background-color: black;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  border: none;
  margin: 1em;
  font-weight: 700;
}

.black-button-submit {
  background-color: black;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  border: none;
  font-weight: 700;
  margin-top: 20px;
  width: 100%;
}

.disable-button-submit {
  background-color: rgb(162, 158, 158);
  color: rgb(255, 254, 254);
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  border: none;
  font-weight: 700;
  margin-top: 20px;
  width: 100%;
}

.conter-with-border {
  background-color: white;
  padding: 10px 20px;
  border-radius: 5px;
  font: 20px;
  border: solid 1px rgba(112, 112, 112, 0.4);
}

.conter-with-border-without-radius {
  margin-top: 20px;
  background-color: white;
  padding: 15px 20px;
  font: 20px;
  border: solid 1px rgba(112, 112, 112, 0.4);
}

.title-text {
  font-weight: bold;
  font-size: 22px;
}

.title-text2 {
  font-size: 12px;
  color: rgb(25, 24, 24);
}

.value-pic-text {
  font-weight: bold;
  font-size: 18px;
}

.value-pic-text2 {
  font-weight: bold;
  font-size: 15px;
  color: rgb(63, 63, 63);
}

.value-pic-text-blue {
  font-size: 15px;
  color: rgb(91, 199, 254);
  cursor: pointer;
  font-weight: 500;
}

.value {
  font-size: 15px;
  color: rgb(0, 0, 0);
}
.padding-left2 {
  padding-left: 10px;
}

.font-size {
  font-size: 13px;
}

.padding-bottom {
  margin-bottom: 20px;
  margin-top: 20px;
}

.button-direction {
  width: 20%;
  text-align: end;
}

.input-textarea {
  width: 100%;
  height: 8em;
  border-radius: 10px;
}

.input-file {
  width: 100%;
  border-radius: 5px;
  font: 20px;
  border: solid 1px rgba(112, 112, 112, 0.4);
  margin-top: 10px;
  margin-bottom: 10px;
  height: 50px;
}

.input-text {
  width: 100%;
  border-radius: 5px;
  font: 20px;
  border: solid 1px rgba(112, 112, 112, 0.4);
  margin-top: 10px;
  margin-bottom: 10px;
  height: 45px;
  padding: 8px;
}

.img-attachment {
  padding: 20px;
  height: 10em;
  cursor: pointer;
}

.width100 {
  width: 100%;
  text-align: center;
}

.file-uploded {
  padding-left: 10px;
  padding-right: 10px;
  background-color: rgb(227, 227, 227);
  border-radius: 15px;
  width: fit-content;
  margin-bottom: 3px;
  margin-top: 3px;
}

.file-uploded-close-icon {
  cursor: pointer;
  font-weight: bold;
}

.file-list {
  display: flex;
  flex-direction: row;
}

.overflow-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.gray-background {
  width: 100%;
  padding: 10px;
  border-radius: 10px;
  font-size: 15px;
  background-color: rgb(228, 228, 228);
}

.center-text {
  text-align: center;
  justify-content: center;
}

.container-uploaded-file {
  margin-top: 20px;
  align-items: center;
  height: 18em;
}

.upload-button {
  background-color: rgb(62, 62, 62);
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  border: none;
  background-color: black;
}

input[type="file"]::file-selector-button {
  text-align: end;
  margin-right: 20px;
  border: none;
  border: 1px solid gray;
  background: transparent;
  padding: 0.625rem 1.25rem;
  border-radius: 5px;
  color: white;
  cursor: pointer;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.11);
  text-align: end;
  background-color: black;
}

.form-input {
  border: none;
  background: #f6fbf4;
  padding: 0.5rem 0.7rem;
  border-radius: 0.23rem;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.11);
  width: 100%;
}

.form-input:focus {
  outline: none;
  box-shadow: 0px 3px 3px 1px rgba(0, 0, 0, 0.2);
}

.form-input-error {
  box-shadow: 0px 0px 3px 1px rgb(255, 50, 46) !important;
}

input[type="file"] {
  width: 140px;
}

input[type="file"]::file-selector-button:hover {
  transform: translateY(-2px);
  box-shadow: 0px 3px 3px 1px rgba(0, 0, 0, 0.2);
}

.error-input {
  font-size: 12px;
  color: var(--error-color);
  margin-top: 0.25rem;
}

.file-list {
  display: flex;
  flex-wrap: wrap;
}

.file {
  margin: 2px;
}

.img-size {
  height: 400px;
  width: 400px;
}

.list-img-container {
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
  max-width: 100%;
  overflow-x: auto;
}

.list-img-container .img-attachment {
  max-width: calc(100%);
  max-height: 600px;
  margin-bottom: 20px;
}

.flex-container {
  display: flex;
  flex-direction: row;
}

.flex-item {
  margin-right: 10px;
}

.container-loading {
  position: relative;
  top: 8px;
  left: 10px;
  align-items: center;
}

.container-loading2 {
  position: relative;
  top: 8px;
  left: 10px;
}

.popover {
  position: relative;
  display: inline-block;
}

.popover-content {
  position: absolute;
  top: 30px;
  right: 0;
  width: 18em;
  background-color: #fff;
  border: 1.5px solid #575555;
  border-radius: 5px;
  padding: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 1;
}

.popover-content button {
  display: block;
  width: 100%;
  padding: 5px;
  border: none;
  background-color: transparent;
  cursor: pointer;
  text-align: left;
}

.popover-content button:hover {
  background-color: #eee;
}

.close-icon {
  cursor: pointer;
}

.red-color-text {
  color: red;
}

.disable-color-text {
  color: rgb(81, 79, 79);
}

.button-red-border {
  background-color: white;
  color: red;
  padding: 10px 20px;
  border-radius: 10px;
  cursor: pointer;
  font-weight: 500;
  margin-top: 10px;
  width: 100%;
  border: 1px solid red;
}
.truncate {
  display: inline-block;
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: bottom;
}
.input-file {
  display: flex;
  align-items: center;
}

.hidden-input {
  position: absolute;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
.drop-area {
  border: 2px dashed #ccc;
  padding: 80px;
  text-align: center;
  position: relative;
}

.drop-area .drop-input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

.drop-area .drop-label {
  display: block;
  margin-bottom: 10px;
  padding-top: 5px;
  font-size: 16px;
  color: #333;
}

.drop-area .custom-button {
  padding: 10px 20px;
  font-size: 16px;
  background-color: #000000;
  color: #fff;
  border: none;
  border-radius: 7px;
  cursor: pointer;
}

.drop-area p {
  margin: 0;
  font-size: 16px;
  color: #333;
}
</style>



